import React from "react";

function BreadCrumb({pageName}) {
  return (
    <div className="pbmit-title-bar-wrapper pbmit-title-bar-style-1" style={{backgroundImage: "URL('assets/images/daily/v1.png')", backgroundPosition: "top center", backgroundRepeat: "no-repeat", backgroundSize: "cover"}}>
      <div className="container">
        <div className="pbmit-title-bar-content">
          <div className="pbmit-title-bar-content-inner">
            <div className="pbmit-tbar">
              <div className="pbmit-tbar-inner container">
                <h1 className="pbmit-tbar-title">{pageName}</h1>
              </div>
            </div>
            <div className="pbmit-breadcrumb">
              <div className="pbmit-breadcrumb-inner">
                <span>
                  <a title="" href="#" className="home">
                    <span>Home</span>
                  </a>
                </span>
                <span className="sep">//</span>
                <span>
                  <span className="post-root post post-post current-item">
                    {pageName}
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BreadCrumb;
